/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type OverviewWeblinks_tradeFirm = {
    readonly serviceId: string | null;
    readonly publicProfile: {
        readonly webLinks: {
            readonly facebook: string | null;
            readonly instagram: string | null;
            readonly pinterest: string | null;
            readonly website: string | null;
        } | null;
    } | null;
    readonly " $refType": "OverviewWeblinks_tradeFirm";
};
export type OverviewWeblinks_tradeFirm$data = OverviewWeblinks_tradeFirm;
export type OverviewWeblinks_tradeFirm$key = {
    readonly " $data"?: OverviewWeblinks_tradeFirm$data;
    readonly " $fragmentRefs": FragmentRefs<"OverviewWeblinks_tradeFirm">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "OverviewWeblinks_tradeFirm",
  "type": "TradeFirmType",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "publicProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "TradeFirmPublicProfileType",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "webLinks",
          "storageKey": null,
          "args": null,
          "concreteType": "WebLinkType",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "facebook",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "instagram",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "pinterest",
              "args": null,
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "website",
              "args": null,
              "storageKey": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = '928d8af0a8f7214ec1de02e5af71c4c2';
export default node;
